import MobileDetect from 'mobile-detect'

declare module '#app' {
  interface NuxtApp {
    $isMobile(): boolean
    $isTablet(): boolean
    $isDesktop(): boolean
  }
}

export default defineNuxtPlugin(() => {
  const headers = useRequestHeaders()

  const userAgent = import.meta.server ? headers['user-agent'] : navigator.userAgent
  const md = new MobileDetect(userAgent)
  const isMobile = md.phone() !== null || md.mobile() === 'UnknownMobile'
  const isTablet = md.tablet() !== null || md.mobile() === 'UnknownTablet'
  const isDesktop = !isMobile && !isTablet

  return {
    provide: {
      isMobile: () => isMobile,
      isTablet: () => isTablet,
      isDesktop: () => isDesktop,
    },
  }
})
